<!--
 Copyright 2024 Google LLC.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<mat-form-field class="new-exp-form-field">
  <mat-label>{{testGroupLabel}}</mat-label>
  <mat-select [formControl]="selectedCovariatesFormControl" multiple>
    <mat-select-trigger>
      <mat-chip-set>
        <mat-chip *ngFor="let covariate of selectedCovariatesFormControl.value"
          [removable]="true" (removed)="removeCovariate(covariate)"
          >{{covariate}}<mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
      </mat-chip-set>
    </mat-select-trigger>
    <mat-option *ngFor="let covariate of covariatesList"
      [value]="covariate">{{covariate}}</mat-option>
  </mat-select>
</mat-form-field>